import Vue from 'vue';

// This is a trick to dynamically crawl the ./components dir
// and automatically import and globally register all component
// files in that dir.  The components will be registered as the
// file name

// https://webpack.js.org/guides/dependency-management/#require-context
const requireComponents = require.context(
  // Search for files in the current directory
  './components',
  // Search for files in subdirectories
  true,
  // Include any .vue files
  /\.vue$/
);

requireComponents.keys().forEach(fileName => {
  // Get the module name and type
  const componentPath = fileName
    // Remove the "./" from the beginning
    .replace(/^\.\//, '');

  const componentName = componentPath
    // Remove the file extension from the end
    .replace(/\.\w+$/, '')
    // Remove the path to the file
    .replace(/^.*[\\\/]/, '');
  Vue.component(componentName, () => import(`./components/${componentPath}`));
});
